import NotificationService from '@/service/notification.service';
import axios from 'axios';

export default {
	state: {
		notifications: [],
		countNotification: 0,
		notificationList: [],
		notificationListCount: 0,
	},

	getters: {
		GETCOUNTNOTIFICATIONS(state) {
			return state.countNotification
		},
		getNotifications(state) {
			return state.notifications
		},
		notificationsList(state) {
			return state.notificationList
		},
		notificationsListCount(state) {
			return state.notificationListCount
		}
	},
	mutations: {
		pushNotification(state, notification) {
			state.notifications.push({
				...notification,
				id: (Math.random().toString(36) + Date.now().toString(36)).substr(2),
			})
		},
		removeNotification(state, notificationToRemove) {
			state.notifications = state.notifications.filter(notification => {
				return notification.id != notificationToRemove.id
			})
		},
		set_notification_count(state, countNotification) {
			state.countNotification = countNotification
		},
		setNotificationsList(state, payload) {
			state.notificationList = payload
		},
		setNotificationsListCount(state, payload) {
			state.notificationListCount = payload
		},
	},
	actions: {
		addNotification({ commit }, notification) {
			commit('pushNotification', notification)
		},
		removeNotification({ commit }, notification) {
			commit('removeNotification', notification)
		},
		getNotifications({ commit }, page) {
			let payload = {
				page: page
			}
			console.log(payload)
			return axios
				.get('notification/', {
					params: payload
				})
				.then(response => {
					let arr = response.data.results
					let count = response.data.count
					arr.map(e => {
						if (e.report == null) {
							return (e.reportName = 'Движение ТМЗ')
						} else {
							return (e.reportName = 'Металлолом')
						}
					})

					console.log(count)

					commit('setNotificationsList', arr)
					commit('setNotificationsListCount', count)
				})
				.catch(error => {
					console.log(error)
				})
		},
		markAllAsRead() {
			axios.get('all_read/')
		},
		getCountNotification({ commit }) {
			return axios.get('count_notification/').then(response => {
				commit('set_notification_count', response.data.count_notification)
				return response.data
			})
		},
	},
}
